export default "__VITE_ASSET__Dl7P$MfG__"